export default "__VITE_ASSET__0129d083__"